// 数值格式化相关的纯函数工具

// 格式化角度参数为一位小数
export function formatAngleValue(value) {
  if (value === undefined || value === null || isNaN(value)) return 0
  return Number(value.toFixed(1))
}

// 安全地格式化数字为一位小数（用于模板显示）
export function safeToFixed(value, decimals = 1) {
  if (value === undefined || value === null || isNaN(value)) return '0.0'
  return Number(value).toFixed(decimals)
}
